module.exports = {"title":"Week 8: Updates with Dr. Sirovic","body":"<p>We continue our tasks with training the data on the CNN and working on the GUI.  Additionally, we begin our documentation on CNNs for future reference.  Lastly, we made a trip down to Scripps to meet up with Ana to update her on our progress with this project after her 3 week absence.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-8/index.md
// module id = 499
// module chunks = 0